function toutou_xy_erreur(message1,message2){

  var ctx = window.ctx_graph;

  if (ctx) {
    ctx.fillStyle = '#FFF';
    ctx.fillRect(0, 0, gxsize, gysize);

    ctx.font = "20px Times New Roman";
    ctx.fillStyle = "#F00";
    ctx.textAlign="center";
    ctx.textBaseline="bottom";
    ctx.fillText('Erreur !', .5*gxsize, .5*gysize);

    ctx.font = "20px Times New Roman";
    ctx.fillStyle = "black";
    ctx.textAlign="center";
    ctx.textBaseline="top";
    ctx.fillText(message1, .5*gxsize, .5*gysize);
    if(message2){
      ctx.fillText(message2, .5*gxsize, .5*gysize+gysize*.15);
    }
  }

}
